import { render, staticRenderFns } from "./Religion.vue?vue&type=template&id=2fe52985&scoped=true&"
import script from "./Religion.vue?vue&type=script&lang=js&"
export * from "./Religion.vue?vue&type=script&lang=js&"
import style0 from "./Religion.vue?vue&type=style&index=0&id=2fe52985&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe52985",
  null
  
)

export default component.exports